import React from 'react';

import { Heading, HeadingProps } from './Heading';
import { Paragraph, ParagraphProps } from './Paragraph';
import { TypographyProps } from './Typography.types';

export function Typography({ variant = 'h1', children, ...props }: TypographyProps) {
  const checkProps = { variant, children, ...props };
  if (variant.substring(0, 1) === 'h') {
    const { variant } = checkProps as HeadingProps;
    return <Heading variant={variant}>{children}</Heading>;
  }
  if (variant.substring(0, 1) === 'p') {
    const paragraphProps = checkProps as ParagraphProps;
    return <Paragraph {...paragraphProps}>{children}</Paragraph>;
  }
}
